/*
 * @Description:
 * @Date: 2020-09-29 10:27:29
 * @LastEditors: jml
 */
import { mapState, mapActions } from "vuex";
import { getStorage } from "@/utils/storage";
import { customerUser } from "@/api/ajax";
export const game = {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      info: (state) => state.game.info,
    }),
    isPreview() {
      const { preview } = this.$route.query;
      return preview == 1;
    },
    isEdit() {
      const { edit } = this.$route.query;
      return edit == 1;
    },
  },
  methods: {
    ...mapActions(["setInfo", "setRewards"]),
    /**
     * 设置logo
     * @param {*} url
     */
    setLogo(url) {
      this.localSetInfo({
        companyLogoUrl: url,
      });
    },
    /**
     * 设置活动开始时间
     * @param {*} timestamp
     */
    setStartDt(timestamp) {
      this.localSetInfo({
        startDt: timestamp,
      });
    },
    /**
     * 设置活动结束时间
     * @param {*} timestamp
     */
    setEndDt(timestamp) {
      this.localSetInfo({
        endDt: timestamp,
      });
    },
    /**
     * 设置活动主办单位
     * @param {*} text
     */
    setOrganizerCompany(text) {
      this.localSetInfo({
        organizerCompany: text,
      });
    },
    /**
     * 设置活动说明
     * @param {*} text
     */
    setActivityExplain(text) {
      this.localSetInfo({
        activityExplain: text,
      });
    },
    /**
     * 设置客服电话
     * @param {*} phone
     */
    setCustomerServicePhone(phone) {
      this.localSetInfo({
        customerServicePhone: phone,
      });
    },
    /**
     * 设置拼图
     * @param {*} url
     */
    setPtUrl(url) {
      this.localSetInfo({
        ptUrl: url,
      });
    },
    /**
     * 设置拼图数量
     * @param {*} number
     */
    setPtNumber(number) {
      if (![9, 16, 25].includes(number)) {
        console.warn("只能传入9,16,25");
        return;
      }
      this.localSetInfo({
        ptNumber: number,
      });
    },
    /**
     * 设置是否开启分享
     * @param {*} status
     */
    setOpenShare(status) {
      this.localSetInfo({
        isOpenShareSum: status,
      });
    },
    /**
     * 设置每日游戏次数
     * @param {*} number
     */
    setDaySum(number) {
      this.localSetInfo({
        daySum: number,
      });
    },
    /**
     * 设置分享增加游戏次数
     * @param {*} number
     */
    setShareSum(number) {
      this.localSetInfo({
        shareSum: number,
      });
    },
    /**
     * 设置开屏广告时间
     * @param {*} number
     */
    setFirstAdvertisementTime(number) {
      this.localSetInfo({
        firstAdvertisementTime: number,
      });
    },
    /**
     * 设置开屏广告图片
     * @param {*} number
     */
    setFirstAdvertisementUrl(url) {
      this.localSetInfo({
        firstAdvertisementUrl: url,
      });
    },
    setRewardsFromAdmin(rewards) {
      if (Object.prototype.toString.call(rewards) != "[object Array]") {
        console.warn("setReward----请传入数组");
        return;
      }
      this.setRewards(
        rewards.reduce((pre, cur) => {
          const {
            integral,
            prizeGrade,
            prizeName,
            prizeType,
            prizeUrl,
            ranking,
          } = cur;
          pre.push({
            integral,
            prizeGrade,
            prizeName,
            prizeType,
            prizeUrl,
            ranking,
          });
          return pre;
        }, [])
      );
    },
    localSetInfo(newInfo, isInit) {
      this.setInfo(isInit ? newInfo : Object.assign(this.info, newInfo));
    },
    localSetRewards(rewards) {
      this.setRewards(rewards);
    },
    async setShareUrl() {
      let {
        data: { data },
      } = await customerUser.obtainLoginUser();
      const { channelNo } = this.$route.params;
      const { pid } = this.$route.query;
      const storageObj = getStorage("channel" + channelNo) || data || {};
      const shareId = storageObj.id || pid;
      if (shareId) {
        const baseUrl = `${window.location.origin}${window.location.pathname}${window.location.hash}`;
        this.url = `${baseUrl.replace(
          "/main",
          ""
        )}?pid=${shareId}&activityReferralCode=${
          this.info.activityCode
        }_${shareId}`;
      } else {
        this.url = "";
      }
      this.$wxShare({
        title: this.info.activityTitle,
        target: this.url,
        imgUrl: this.info.shareIcon,
        desc: this.info.shareDescribe,
      });
    },
  },
  watch: {},
  created() {
    if (this.isEdit) {
      window.setLogo = this.setLogo;
      window.setPtUrl = this.setPtUrl;
      window.setPtNumber = this.setPtNumber;
      window.setStartDt = this.setStartDt;
      window.setEndDt = this.setEndDt;
      window.setOrganizerCompany = this.setOrganizerCompany;
      window.setActivityExplain = this.setActivityExplain;
      window.setCustomerServicePhone = this.setCustomerServicePhone;
      window.setRewards = this.setRewardsFromAdmin;
      window.setOpenShare = this.setOpenShare;
      window.setDaySum = this.setDaySum;
      window.setShareSum = this.setShareSum;
      window.setFirstAdvertisementTime = this.setFirstAdvertisementTime;
      window.setFirstAdvertisementUrl = this.setFirstAdvertisementUrl;
    }
  },
};
